import { render, staticRenderFns } from "./SoSoft.vue?vue&type=template&id=6d1b682c&scoped=true&"
import script from "./SoSoft.vue?vue&type=script&lang=js&"
export * from "./SoSoft.vue?vue&type=script&lang=js&"
import style0 from "./SoSoft.vue?vue&type=style&index=0&id=6d1b682c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1b682c",
  null
  
)

export default component.exports